import { Routes, Route } from 'react-router-dom';
import Auth from '../pages/Auth';
import Home from '../pages/Home';
import Experience from '../pages/Experience';
import AboutPage from '../pages/About';
import PricingPage from '../pages/Pricing';
import Profile from '../pages/Profile';
import BookingHistory from '../pages/BookingHistory';
import ImageUploader from '../components/ImageUploader';
import Checkout from '../pages/Checkout';
import JoinPublicRoom from '../pages/JoinPublicRoom';
import Services from '../pages/Services';
import Contact from '../pages/Contact';
import Thanks from '../pages/Thanks';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/auth" element={<Auth />} />
+     {/* RUTA SEO LANDING */}
      <Route path="/laser-tag-cornwall" element={<Home />} />
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/exp" element={<Experience />} />
      <Route path="/about" element={<AboutPage />} /> 
      <Route path="/pricing" element={<PricingPage />} /> 
      <Route path="/image-uploader" element={<ImageUploader />} /> 
      <Route path="/checkout" element={<Checkout />} />
  <Route path="/checkout/:gameId" element={<Checkout />} />
  <Route path="/join-public/:gameId" element={<JoinPublicRoom />} />
  <Route path="/join-public-room" element={<JoinPublicRoom />} />
  <Route path="/thanks" element={<Thanks />} />
      <Route path="/services" element={<Services />} />
      <Route path="/contact" element={<Contact />} />
  <Route path="/profile" element={<Profile />} />
  <Route path="/booking-history" element={<BookingHistory />} />
    </Routes>
  );
};

export default AppRoutes;
